import axios from "axios";

export const state = {
    withdraws: [],
};

export const getters = {
    withdraws: state => state.withdraws,
};

export const mutations = {
    setWithdraws(state, newValue) {
        state.withdraws = newValue
    },
};

export const actions = {
    fetchWithdraws({ commit }) {
        axios.get('/withdraws').then(res => {
            commit('setWithdraws', res.data.withdraws);
        })
    },
    filterWithdraws({commit}, {schoolterm,year}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        let url = "/filterwithdraws";
        axios.post(url, formData).then((response) => {
            commit('setWithdraws', response.data.withraws)
        })
    },
   
};
